export default __webpack_public_path__ + "static/media/frangot-mobile-1.efc34612.png";